import CheckAll from "./js/CheckAll";
export default CheckAll;